<template>
  <div class="p-4">
    <div class="flex gap-4 items-center">
      <div>
        <profile-photo
          :color="org ? org.orgColor : null"
          :photo-url="
            org
              ? org.orgLogo
                ? org.orgLogo.url
                : null
              : user
              ? user.photoUrl
              : null
          "
          :fallback="org ? 'org' : 'user'"
          size="lg"
        />
      </div>
      <div>
        <h2 class="text-lg">
          <template v-if="org">
            {{ org.title }}
          </template>
          <template v-else> Personal </template>
        </h2>

        <template v-if="showDetails">
          <div class="text-gray-500 text-sm">
            <template v-if="cart && cart.totalPrice > 0">
              {{ $filters.currency(cart.totalPrice) }}
              —
            </template>
            {{ totalItems }} {{ totalItems === 1 ? 'item' : 'items' }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import ProfilePhoto from '@console/components/ProfilePhoto.vue';

  export default {
    components: {ProfilePhoto},
    props: {
      orgId: {
        type: Number,
        required: false,
        default: null,
      },
      showDetails: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      ...mapState({
        user: (state) => state.account.user,
      }),

      cart() {
        return this.user.carts.find((cart) => cart.orgId === this.orgId);
      },

      totalItems() {
        return this.cart ? this.cart.totalQty : 0;
      },

      org() {
        return this.orgId
          ? this.$store.getters['orgs/getOrg'](this.orgId)
          : null;
      },
    },
  };
</script>
